import React, { Component } from 'react';
import Text from 'react-format-text';
import {
  Comment,
  Flag,
  Header,
  Segment,
} from 'semantic-ui-react';

import { Gallery as ReactGallery } from '../../ReactGridGallery';
import {
  CustomContainer,
} from '../../common';
import {
  UserLink,
} from '../../Links';
import {
  checkImageURL,
  formatTimestamp,
  getPushIcon,
  getUrls,
  getUserAvatar,
  parseImgurURL,
} from '../../Utils';

class Push extends Component {
  state = {
    urls: [],
  }

  componentDidMount() {
    const {
      content,
    } = this.props;

    const urls = getUrls(content);
    const validURLS = urls
      .map((url) => parseImgurURL(url))
      .filter((url) => checkImageURL(url));

    this.setState({
      urls: validURLS,
    });
  }

  render() {
    const {
      city,
      code2,
      content,
      country,
      floor,
      tag,
      timestp,
      userId,
    } = this.props;

    const { urls } = this.state;

    return (
      userId && content && (
        <div>
          <Comment>
            <Comment.Avatar
              src={getUserAvatar(userId)}
            />
            <Comment.Content>
              {
                floor && (
                  <span style={{ color: '#1abc9c' }}>
                    <b>
                      {floor}
                      樓
                    </b>
                  </span>
                )
              }
              <Comment.Metadata>
                {getPushIcon(tag, 'large')}
              </Comment.Metadata>
              <UserLink id={userId}>
                <Comment.Author as="a">
                  {userId}
                </Comment.Author>
              </UserLink>
              <Comment.Metadata>
                {formatTimestamp(timestp)}
              </Comment.Metadata>
              {
                code2 && (
                  <Comment.Metadata>
                    {city}
                    {' '}
                    (
                    {country}
                    {' '}
                    <Flag name={code2} />
                    )
                  </Comment.Metadata>
                )
              }
              <Comment.Text>
                <Text>
                  {content}
                </Text>
                {
                  urls.length > 0 && (
                    <picture>
                      <ReactGallery
                        enableImageSelection={false}
                        images={urls.map(url => ({
                          src: url,
                        }))}
                      />
                    </picture>
                  )
                }
              </Comment.Text>
            </Comment.Content>
          </Comment>
        </div>
      )
    );
  }
}

export default ({ data, total, isMobile }) => {
  const shouldShowFloors = data.filter(
    (push) => push.floor !== null,
  ).length === data.length;

  return (
    Array.isArray(data) && data.length > 0 && (
      <CustomContainer>
        <Header
          as={isMobile ? 'h3' : 'h2'}
          attached="top"
        >
          推 / 噓 / 回文 (
          {total}
          )
        </Header>
        <Segment attached>
          <Comment.Group size={isMobile ? 'small' : 'large'}>
            {data.map((push) => (
              <Push
                city={push.city}
                code2={push.code2}
                content={push.content}
                country={push.country}
                floor={shouldShowFloors ? push.floor : null}
                key={push.id}
                tag={push.tag}
                timestp={push.timestp}
                userId={push.user_id}
              />
            ))}
          </Comment.Group>
        </Segment>
      </CustomContainer>
    )
  );
};
